import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import QuizquestionList from './quizquestion-list.component';
import QuizquestionCreate from './quizquestion-create.component';
import QuizquestionView from './quizquestion-view.component';
import QuizquestionEdit from './quizquestion-edit.component';
import QuizquestionCopy from './quizquestion-copy.component';
import QuizquestionDelete from './quizquestion-delete.component';

interface Props {
  root?: string;
}

export const QuizquestionRoute: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={(props.root||'') + '/quizquestion/create'} component={QuizquestionCreate} />
      <Route path={`${props.root||''}/quizquestion/view`} render={(params) => <QuizquestionView {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={`${props.root||''}/quizquestion/edit`} render={(params) => <QuizquestionEdit {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={(props.root||'') + '/quizquestion/copy'} component={QuizquestionCopy} />
      <Route path={`${props.root||''}/quizquestion/delete`} render={(params) => <QuizquestionDelete {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={(props.root||'') + '/quizquestion'} component={QuizquestionList} />
    </Switch>
  );
}
